<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div *ngIf="!isAssessors" class="flex gap-10">
        <h3 class="bold header_title" style="width: 100%; text-align: center;">CONFIRMATION DE LA REPRISE DE VOTE
        </h3>
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
      </div>

      <div class="dark-blue" style="text-align: center;">
        <img src="assets/resumed-poll-icon.svg" style="margin-bottom: 30px;">
        <p class="text-md" style="margin: 5px 0px 5px 17px">Le vote est de nouveau accessible.</p>
      </div>

      <div class="dark-blue">
        <h1 class="text-md" style="margin: 13px 0px 5px 0px;">"{{title}}"</h1>
        <p class="text-md dark-blue flex align-items-center"><img src="assets/calendar25.svg" class="icon-inline"
            style="margin-right: 10px;"> Période du scrutin : du
          {{startDate}} au {{endDate}}</p>
        <p class="text-md dark-blue"><img width="18px" id="silhouette" style="margin-right: 10px;"
            src="assets/silhouette_icon_black.svg">Invités au scrutin : <span class="bold">{{votersCount}}</span></p>
      </div>
    </div>
  </div>
</div>